import { render, staticRenderFns } from "./ProductImageViewerCmp.vue?vue&type=template&id=891bd406&scoped=true&"
import script from "./ProductImageViewerCmp.vue?vue&type=script&lang=js&"
export * from "./ProductImageViewerCmp.vue?vue&type=script&lang=js&"
import style0 from "./ProductImageViewerCmp.vue?vue&type=style&index=0&id=891bd406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891bd406",
  null
  
)

export default component.exports